module.exports = __webpack_public_path__ + "static/3-aea0323ea69e7a7b86580f50cd65f7d5.jpg";